import { Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.dev';
import {
  InformationDto,
  ProcessInformationDto,
} from '../dto/justino/information.dto';

@Injectable({
  providedIn: 'root',
})
export class GestionInformacionService {
  baseUrl = `${environment.justinoApiUrl}/api/`;
  
  informatioSubject = new Subject<null>();
  informatioSubject$ = this.informatioSubject.asObservable();

  constructor(private readonly http: HttpClient) {}

  getDocumentalInfoRegisters(entityId: number): Observable<InformationDto[]> {
    const getUrl = `${this.baseUrl}document-information/${entityId}`;

    return this.http.get<InformationDto[]>(getUrl);
  }

  createDocumentalInfoRegister(
    data: InformationDto
  ): Observable<InformationDto> {
    const createUrl = `${this.baseUrl}document-information`;

    return this.http.post<InformationDto>(createUrl, data);
  }

  updateDocumentalInfoRegister(
    data: InformationDto
  ): Observable<InformationDto> {
    const updateUrl = `${this.baseUrl}document-information/${data.Id}`;

    return this.http.put<InformationDto>(updateUrl, data).pipe(
      tap(() => {
        this.informatioSubject.next(null);
      })
    );
  }

  deleteDocumentalInfoRegister(id: number): Observable<void> {
    const deleteUrl = `${this.baseUrl}document-information/${id}`;

    return this.http.delete<void>(deleteUrl);
  }

  getProcesses(entityId: number): Observable<ProcessInformationDto[]> {
    const processesUrl = `${this.baseUrl}processes/${entityId}`;

    return this.http.get<ProcessInformationDto[]>(processesUrl).pipe(
      tap(() => {
        this.informatioSubject.next(null);
      })
    );
  }
}
